export const zhCNWorkspaceAgentProbeQuota = {
  workspaceAgentProbeQuotaCredits: "积分",
  workspaceAgentProbeQuotaCreditsRemaining: "剩余 {{amount}} Credits",
  workspaceAgentProbeQuotaDollarRemaining: "剩余 ${{amount}}",
  workspaceAgentProbeQuotaRemaining: "剩余 {{percent}}%"
} as const;
